import React from 'react'
import { Grid } from '@mui/material';

const Item = () => {
    return (
        <div className='item skeleton-item'>
            <div className="skeleton-image-wrapper">
                <div className="skeleton-shimmer"></div>
            </div>
            <div className="skeleton-text skeleton-name"></div>
            <div className="item-prices">
                <div className="skeleton-text skeleton-price-new"></div>
                <div className="skeleton-text skeleton-price-old"></div>
            </div>
        </div>
    );
};

const ItemSkeleton = ({ count = 4 }) => {
    return (
        [...Array(count)].map((_, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={`skeleton-${index}`}>
                <Item />
            </Grid>
        ))
    )
}

export default ItemSkeleton